import { FC } from 'react'
import { Link } from 'react-router-dom'

import { CourseTabTitle } from 'share/domain/course'
import ContentNotAvailable from 'components/atoms/ContentNotAvailable'

const CourseTabCourseOrderedForSpouse: FC = () => (
  <ContentNotAvailable
    title={CourseTabTitle.COURSE_FOR_SPOUSE}
    datatestid='course-tab-ordered-for-spouse-content'
  >
    Your spouse is taking the bankruptcy course for your joint case. Please{' '}
    <Link to='/dashboard/lawfirminformation'>contact your attorney</Link> for
    more information.
  </ContentNotAvailable>
)

export default CourseTabCourseOrderedForSpouse
